var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useEffect, useCallback, Children, } from 'react';
import styled from '@emotion/styled';
import Glide, { Swipe, Images, Anchors, Controls, Autoplay, Keyboard, } from '@glidejs/glide/dist/glide.modular.esm';
import inRange from 'lodash/inRange';
import GetElementWidth from '../GetElementWidth';
import { bottom, overflow, } from 'styled-system';
var GlideWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  box-sizing: border-box;\n"], ["\n  position: relative;\n  width: 100%;\n  box-sizing: border-box;\n"])));
var GlideTrack = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  overflow: ", ";\n"], ["\n  overflow: ", ";\n"])), function (_a) {
    var frameOverflow = _a.frameOverflow;
    return frameOverflow || 'hidden';
});
var GlideSlides = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n  overflow: ", ";\n  position: relative;\n  width: 100%;\n  list-style: none;\n  backface-visibility: hidden;\n  transform-style: preserve-3d;\n  touch-action: pan-Y;\n  padding: 0;\n  white-space: nowrap;\n  display: flex;\n  flex-wrap: nowrap;\n  will-change: transform;\n"], ["\n  ", "\n  overflow: ", ";\n  position: relative;\n  width: 100%;\n  list-style: none;\n  backface-visibility: hidden;\n  transform-style: preserve-3d;\n  touch-action: pan-Y;\n  padding: 0;\n  white-space: nowrap;\n  display: flex;\n  flex-wrap: nowrap;\n  will-change: transform;\n"])), function (_a) {
    var centerSlides = _a.centerSlides;
    return centerSlides && 'margin: auto;';
}, function (_a) {
    var sliderOverflow = _a.sliderOverflow;
    return sliderOverflow || 'hidden';
});
var GlideSlide = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 100%;\n  flex-shrink: 0;\n  white-space: normal;\n  user-select: none;\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: transparent;\n"], ["\n  width: 100%;\n  flex-shrink: 0;\n  white-space: normal;\n  user-select: none;\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: transparent;\n"])));
var GlideBottomControls = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n"], ["\n  ", ";\n  ", ";\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n"])), overflow, bottom);
GlideBottomControls.defaultProps = {
    bottom: 0,
};
var GlideCarousel = /** @class */ (function (_super) {
    __extends(GlideCarousel, _super);
    function GlideCarousel(props) {
        var _this = _super.call(this, props) || this;
        _this.carouselId = GlideCarousel.lastUsedId++;
        _this.glide = null;
        _this.state = {
            containerWidth: props.initialContainerWidth,
            cloneSlideWidth: 0,
        };
        _this.carouselId = GlideCarousel.lastUsedId++;
        _this.setContainerWidth = _this.setContainerWidth.bind(_this);
        _this.nextSlide = _this.nextSlide.bind(_this);
        _this.previousSlide = _this.previousSlide.bind(_this);
        _this.goToSlide = _this.goToSlide.bind(_this);
        return _this;
    }
    GlideCarousel.prototype.calculateSlidesPerView = function () {
        var containerWidth = this.state.containerWidth;
        var _a = this.props, cellSpacing = _a.cellSpacing, fixedSlideWidth = _a.fixedSlideWidth, slidesToShow = _a.slidesToShow, children = _a.children;
        if (fixedSlideWidth) {
            var slidesCount = React.Children.count(children);
            var containerWidthWithGap = containerWidth + cellSpacing;
            var slideWidthWithGap = fixedSlideWidth + cellSpacing;
            return Math.min(Math.floor(containerWidthWithGap / slideWidthWithGap), slidesCount);
        }
        return slidesToShow;
    };
    GlideCarousel.prototype.calculatePeekAfter = function (perView) {
        var containerWidth = this.state.containerWidth;
        var _a = this.props, cellSpacing = _a.cellSpacing, fixedSlideWidth = _a.fixedSlideWidth, slideWidth = _a.slideWidth;
        if (fixedSlideWidth) {
            var containerWidthWithGap = containerWidth + cellSpacing;
            var slideWidthWithGap = fixedSlideWidth + cellSpacing;
            return containerWidthWithGap - perView * slideWidthWithGap;
        }
        return containerWidth !== null ? containerWidth * (1 - slideWidth) : 0;
    };
    GlideCarousel.prototype.getGlideSettings = function () {
        var _a = this.props, autoplay = _a.autoplay, autoplayInterval = _a.autoplayInterval, cellSpacing = _a.cellSpacing, fixedSlideWidth = _a.fixedSlideWidth, pauseOnHover = _a.pauseOnHover, scrollToTheLastSlide = _a.scrollToTheLastSlide, startAt = _a.startAt, keyboard = _a.keyboard, wrapAround = _a.wrapAround, swipeThreshold = _a.swipeThreshold, perTouch = _a.perTouch, children = _a.children;
        var slidesCount = React.Children.count(children);
        var perView = this.calculateSlidesPerView();
        var peekAfter = this.calculatePeekAfter(perView);
        var swipeConfiguration = slidesCount <= perView ? false : fixedSlideWidth || 80;
        return {
            swipeThreshold: swipeThreshold ? swipeThreshold : swipeConfiguration,
            dragThreshold: swipeConfiguration,
            type: wrapAround ? 'carousel' : 'slider',
            rewind: !!wrapAround,
            bound: !scrollToTheLastSlide,
            perView: perView,
            gap: cellSpacing,
            autoplay: autoplay ? autoplayInterval : false,
            hoverpause: pauseOnHover,
            peek: {
                after: peekAfter,
                before: 0,
            },
            startAt: startAt < perView ? 0 : startAt,
            keyboard: keyboard,
            perTouch: perTouch,
        };
    };
    GlideCarousel.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.disabled) {
            return;
        }
        var settings = this.getGlideSettings();
        var slidesCount = Children.toArray(this.props.children).length;
        this.glide = new Glide("#glide-" + this.carouselId, settings)
            .on('run.before', function (_a) {
            var direction = _a.direction;
            var perView = settings.perView;
            var index = _this.glide.index;
            if (_this.props.beforeSlide) {
                _this.props.beforeSlide();
            }
            if (inRange(perView, 2, 4)) {
                if (direction === '>') {
                    if (index + 1 < slidesCount) {
                        var nextIndex = index + 1;
                        _this.glide.index = nextIndex;
                    }
                }
                else {
                    var prevIndex = index - 1;
                    _this.glide.index = prevIndex;
                }
            }
        })
            .on('run.after', function () {
            if (_this.props.afterSlide) {
                _this.props.afterSlide(_this.glide.index);
            }
        });
        this.glide.mount({
            Swipe: Swipe,
            Images: Images,
            Anchors: Anchors,
            Controls: Controls,
            Autoplay: Autoplay,
            Keyboard: Keyboard,
            // override default Clones extension because clones aren't aware of
            // changes in react components in runtime. Clones are created using
            // react, but glide still use this extension to calculate width of all
            // clones
            Clones: function (_, Components, EventBus) {
                // during these events slideWidth can change, we add listener here
                // because of access to instances of Sizes Glide extension
                EventBus.on(['update', 'build.before'], function () {
                    if (_this.glide.isType('carousel')) {
                        _this.setState({
                            cloneSlideWidth: Components.Sizes.slideWidth,
                        });
                    }
                });
                return Object.defineProperty({}, 'grow', {
                    /* Gets additional dimensions value caused by clones.*/
                    get: function () {
                        // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
                        return (Components.Sizes.slideWidth + Components.Gaps.value) *
                            _this.getCloneCount() *
                            2;
                    },
                });
            },
        });
    };
    GlideCarousel.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _a = this, props = _a.props, state = _a.state;
        if (props.disabled) {
            return;
        }
        if (props.wrapAround !== prevProps.wrapAround ||
            props.swipeThreshold !== prevProps.swipeThreshold ||
            props.scrollToTheLastSlide !== prevProps.scrollToTheLastSlide ||
            props.slidesToShow !== prevProps.slidesToShow ||
            props.cellSpacing !== prevProps.cellSpacing ||
            props.autoplay !== prevProps.autoplay ||
            props.autoplayInterval !== prevProps.autoplayInterval ||
            props.pauseOnHover !== prevProps.pauseOnHover ||
            props.slideWidth !== prevProps.slideWidth ||
            props.fixedSlideWidth !== prevProps.fixedSlideWidth ||
            props.startAt !== prevProps.startAt ||
            props.keyboard !== prevProps.keyboard ||
            React.Children.count(props.children) !==
                React.Children.count(props.children) ||
            props.perTouch !== prevProps.perTouch ||
            state.containerWidth !== prevState.containerWidth) {
            var newSettings = this.getGlideSettings();
            this.glide.update(newSettings);
        }
        if (props.goToIndex !== null && props.goToIndex !== prevProps.goToIndex) {
            this.goToSlide(props.goToIndex);
        }
    };
    GlideCarousel.prototype.componentWillUnmount = function () {
        if (this.glide) {
            this.glide.destroy();
        }
    };
    GlideCarousel.prototype.setContainerWidth = function (width) {
        this.setState({ containerWidth: width });
    };
    GlideCarousel.prototype.previousSlide = function () {
        if (this.glide) {
            var slidesToScroll = this.props.slidesToScroll || this.props.slidesToShow;
            this.glide.go("<" + slidesToScroll);
        }
    };
    GlideCarousel.prototype.nextSlide = function () {
        if (this.glide) {
            var slidesToScroll = this.props.slidesToScroll || this.props.slidesToShow;
            // for unknown reason glide requires negative number
            // when going right n slides
            this.glide.go(">" + -slidesToScroll);
        }
    };
    GlideCarousel.prototype.goToSlide = function (newIndex) {
        if (this.glide) {
            this.glide.go("=" + newIndex);
        }
    };
    GlideCarousel.prototype.getCloneCount = function () {
        var _a = this.props, slidesToShow = _a.slidesToShow, slideWidth = _a.slideWidth, wrapAround = _a.wrapAround;
        if (!wrapAround) {
            return null;
        }
        var peekIncrementer = slideWidth !== null && slideWidth !== 1 ? 1 : 0;
        return slidesToShow + peekIncrementer + Math.round(slidesToShow / 2);
    };
    GlideCarousel.prototype.render = function () {
        var _this = this;
        var _a = this.props, slideWidth = _a.slideWidth, fixedSlideWidth = _a.fixedSlideWidth, scrollToTheLastSlide = _a.scrollToTheLastSlide, frameOverflow = _a.frameOverflow, sliderOverflow = _a.sliderOverflow, renderCenterLeftControls = _a.renderCenterLeftControls, renderCenterRightControls = _a.renderCenterRightControls, renderBottomCenterControls = _a.renderBottomCenterControls, centerSlides = _a.centerSlides, children = _a.children, startAt = _a.startAt, wrapAround = _a.wrapAround, bottomControlsOverflow = _a.bottomControlsOverflow, bottomControlsVerticalPosition = _a.bottomControlsVerticalPosition;
        var cloneSlideWidth = this.state.cloneSlideWidth;
        var childrenArray = Children.toArray(children);
        var slideCount = childrenArray.length;
        var cloneCount = this.getCloneCount();
        var appendClones = childrenArray.slice(0, cloneCount);
        var prependClones = childrenArray.slice(slideCount - cloneCount);
        var slidesPerView = this.calculateSlidesPerView();
        return (React.createElement(GlideWrapper, { id: "glide-" + this.carouselId, className: "glide" },
            React.createElement(GetElementWidth, { onWidthChange: this.setContainerWidth, disabled: (slideWidth === null || slideWidth === 1) && !fixedSlideWidth },
                React.createElement(GlideTrack, { className: "glide__track", "data-glide-el": "track", frameOverflow: frameOverflow },
                    React.createElement(GlideSlides, { centerSlides: centerSlides, className: "glide__slides", sliderOverflow: sliderOverflow },
                        prependClones.map(function (child, i) { return (React.createElement(GlideSlide, { className: "glide__slide glide__slide--clone", key: "prepend-clone-" + i, style: { width: cloneSlideWidth } }, child)); }),
                        childrenArray.map(function (child, i) { return (React.createElement(GlideSlide, { className: "glide__slide", key: i }, child)); }),
                        appendClones.map(function (child, i) { return (React.createElement(GlideSlide, { className: "glide__slide glide__slide--clone", key: "append-clone-" + i, style: { width: cloneSlideWidth } }, child)); })))),
            React.createElement(GlideCurrentSlide, { glide: this.glide, initialSlide: startAt }, function (currentSlide) { return (React.createElement(React.Fragment, null,
                renderCenterLeftControls
                    ? renderCenterLeftControls({
                        previousSlide: _this.previousSlide,
                        currentSlide: currentSlide,
                        slideCount: slideCount,
                        slidesToShow: slidesPerView,
                        wrapAround: wrapAround,
                    })
                    : null,
                renderCenterRightControls
                    ? renderCenterRightControls({
                        nextSlide: _this.nextSlide,
                        currentSlide: currentSlide,
                        slideCount: slideCount,
                        slidesToShow: slidesPerView,
                        canScrollToTheLastSlide: scrollToTheLastSlide,
                        wrapAround: wrapAround,
                    })
                    : null,
                renderBottomCenterControls ? (React.createElement(GlideBottomControls, { overflow: bottomControlsOverflow, bottom: bottomControlsVerticalPosition }, renderBottomCenterControls({
                    currentSlide: currentSlide,
                    slideCount: slideCount,
                    goToSlide: _this.goToSlide,
                }))) : null)); })));
    };
    GlideCarousel.defaultProps = {
        slidesToShow: 1,
        perTouch: false,
        cellSpacing: 0,
        autoplay: false,
        autoplayInterval: 3000,
        pauseOnHover: false,
        slideWidth: null,
        scrollToTheLastSlide: false,
        disabled: false,
        startAt: 0,
        keyboard: false,
    };
    GlideCarousel.lastUsedId = 0;
    return GlideCarousel;
}(React.Component));
export { GlideCarousel };
function GlideCurrentSlide(_a) {
    var glide = _a.glide, children = _a.children, _b = _a.initialSlide, initialSlide = _b === void 0 ? 0 : _b;
    var _c = __read(useState(initialSlide), 2), currentSlide = _c[0], setCurrentSlide = _c[1];
    var onIndexUpdate = useCallback(function () { return setCurrentSlide(glide.index); }, [
        glide,
    ]);
    useEffect(function () {
        if (glide) {
            // glide event listeners cannot be unsubscribed.
            // This one is thankfully applied only once and it will be
            // cleared when glide instance is destroyed nonetheless
            glide.on('run', onIndexUpdate);
            glide.on('update', onIndexUpdate);
        }
    }, [glide]);
    return children(currentSlide);
}
export default GlideCarousel;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
